export const styles = {
  root: 'mt-safe h-2xl w-full',
  button: 'px-lg w-[6.4rem] h-full justify-center items-center',
};
